module.exports = __webpack_public_path__ + "static/media/video.1173bebc.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/video.svg
// module id = 471
// module chunks = 0